import { render } from "./ReportThemeCreate.vue?vue&type=template&id=32767e30"
import script from "./ReportThemeCreate.vue?vue&type=script&lang=js"
export * from "./ReportThemeCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__